import { render, staticRenderFns } from "./groupBtnPermission.vue?vue&type=template&id=29e752d5&scoped=true&"
import script from "./groupBtnPermission.vue?vue&type=script&lang=js&"
export * from "./groupBtnPermission.vue?vue&type=script&lang=js&"
import style0 from "./groupBtnPermission.vue?vue&type=style&index=0&id=29e752d5&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29e752d5",
  null
  
)

export default component.exports